module.exports = __webpack_public_path__ + "img/v1_cup.54b70256.svg";